import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum IDRequested {
  Genitori = '1',
  Padre = '2',
  Madre = '3',
  Nessuno = '4',
}

const requestedList = Object.freeze([
  {
    id: IDRequested.Genitori,
    value: 'Entrambi i genitori',
  },
  {
    id: IDRequested.Padre,
    value: 'Solo dal padre',
  },
  {
    id: IDRequested.Madre,
    value: 'Solo dalla madre',
  },
  {
    id: IDRequested.Nessuno,
    value: 'Da nessuno',
  },
]);

interface RequestedListProps {
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const RequestedListComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
}: RequestedListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="requested-list-label">
        {required ? "E' riconosciuto *" : "E' riconosciuto"}
      </InputLabel>
      <PmiSelect
        labelId="requested-list-label"
        id="requested-list"
        name="requested-list"
        value={value}
        label={required ? "E' riconosciuto *" : "E' riconosciuto"}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {requestedList.map((requested: ItemVM) => (
          <MenuItem key={requested.id} value={requested.id}>
            {requested.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

RequestedListComponent.displayName = 'List requested list component';

const RequestedList = memo(RequestedListComponent);

export default RequestedList as typeof RequestedListComponent;
